
export class YFC {

	static USER_COOKIE = `YF-customer-${process.env.VUE_APP_STORE_CODE}ELAdminUser`;
	static TOKEN_COOKIE = `YF-customer-${process.env.VUE_APP_STORE_CODE}ELAdminToken`;
	static CART_COOKIE = `YF-usercart-${process.env.VUE_APP_STORE_CODE}`;
	static I18N_COOKIE = `YF-customer-${process.env.VUE_APP_STORE_CODE}Lang`;
	static WISHLIST_COOKIE = `YF-wishlist-${process.env.VUE_APP_STORE_CODE}`;
	static WISHLIST_MERGED_COOKIE = `YF-wishlist-merged-${process.env.VUE_APP_STORE_CODE}`;

	static NEWSLETTER_COOKIE = `YF-newsletter-${process.env.VUE_APP_STORE_CODE}`;

	static EVENT_USER = "YCFeventUser";
	static EVENT_CART = "YCFeventCart";
	static EVENT_SHOP_CONF = "YCFeventShopConf";
	static EVENT_INIT = "YCFeventInit";
	static EVENT_I18N = "YCFeventI18n";
	static EVENT_URL_SEARCH_PARAMS = "YCFeventUrlSearchParams";

	static QUERY_PARAM_SEPARATOR = "_";
	static QUERY_PARAM_SEPARATOR_ARRAY = ".";
	static QUERY_PARAM_ATTRIBUTE_PFX = "a" + YFC.QUERY_PARAM_SEPARATOR;
	static QUERY_PARAM_PRICE_MIN = "pricemin";
	static QUERY_PARAM_PRICE_MAX = "pricemax";

}